<app-link-trip #linkComponent [showActionButtons]="false" [incidentId]="incidentId" [trips]="trips"
  (onLink)="onLink($event)">
</app-link-trip>

<div class="p-dialog-footer">
  @if (linkMode === 'link') {
    <button type="button" pButton class=""
    (click)="linkComponent.linkTrip()">Link</button>
  }
  @if (linkMode === 'unlink') {
    <button type="button" pButton class=""
    (click)="linkComponent.unlinkTrip()">Unlink</button>
  }
  <button type="button" pButton class="p-button-outlined" (click)="modalRef.close('dismissed')">Close</button>
</div>
